import React,{useState, useEffect}  from 'react';
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csintro(){

    const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
        <Sides/>
        <Helmet>
 
 <title>C# introduction tutorial For Beginners</title>
 <meta name="description" content="C# introduction tutorial for beginners.introduction in C# is a case sensitive language, C# is a popular language because it is reliable, easy to use and simple CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,C# introduction,c# introduction for,c sharp introduction,c# introduction for loop,c# continue,introduction foreach c#,c# foreach introduction,C# Basic introduction Tutorial for begineers" />
 <link rel="canonical" href="https://www.codeexampler.com/csharp-introduction" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">Csharp(C#) Introduction</h1>
    <div className="first">
        <a href="/csharp-history">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
       
        </div>
<p className="mt-4 para ">
1. C# is a case sensitive language<br/>
2. C# is a popular language because it is reliable, easy to use and simple<br/>
3. C# key that allowed to solve both the security and the portability problems.<br/>
4. C# and IDE make it easy for you to get writing code and also written fastly.<br/>
5. C# Support a new XML style of inline documentation.<br/>
6. C# symbols are very similar to c# programming language.<br/>
7. Csharp gives an easy transition for a c# programmer.<br/>
8. This Csharp is a high performance and dynamic</p>

  <h1 className="mt-5">  </h1>
   
  <div className="back">
        <a href="/csharp-history">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
       
        </div>
        </div>
    </div>
)

}
export default Csintro;